import request from './http';
//通用 顶部菜单 getMenu
export const getMenu = (query) => {
    return request({
        url: '/getMenu',
        method: 'post',
        data: query
    })
}

//通用 底部 getFooter
export const getFooter = (query) => {
    return request({
        url: '/getMenuList',
        method: 'post',
        data: query
    })
}

//通用 公司信息 
export const getCompanyConfig = (query) => {
    return request({
        url: '/getCompanyConfig',
        method: 'post',
        data: query
    })
}

//首页banner
export const getBanner = (query) => {
    return request({
        url: '/getBanner',
        method: 'post',
        data: query
    })
}
//首页 关于我们
export const indexAboutUs = (query) => {
    return request({
        url: '/indexAboutUs',
        method: 'post',
        data: query
    })
}

//首页  中间定位
export const getMagic = (query) => {
    return request({
        url: '/getMagic',
        method: 'post',
        data: query
    })
}

//文章列表
export const getArticleListByFunc = (query) => {
    return request({
        url: '/getArticleListByFunc',
        method: 'post',
        data: query
    })
}

//文章详情/
export const getArticleInfoById = (query) => {
    return request({
        url: '/getArticleInfoById',
        method: 'post',
        data: query
    })
}

//第一篇文章详情 getArticleInfoByFunc
export const getArticleInfoByFunc = (query) => {
    return request({
        url: '/getArticleInfoByFunc',
        method: 'post',
        data: query
    })
}

//企业领导人 
export const getLeader = (query) => {
    return request({
        url: '/getLeader',
        method: 'post',
        data: query
    })
}

//在线留言
export const setMessage = (query) => {
    return request({
        url: '/setMessage',
        method: 'post',
        data: query
    })
}

//招聘getRecruitment
export const getRecruitment = (query) => {
    return request({
        url: '/getRecruitment',
        method: 'post',
        data: query
    })
}

//get
export const getBanners = (query) => {
    return request({
        url: '/getBanner',
        method: 'get',
        params: query
    })
}

//获取经营邻域我们的车间介绍数据
export const getTopArticleInfoByFunc = (query) => {
    return request({
        url: '/getTopArticleInfoByFunc',
        method: 'post',
        data: query
    })
}


// WEBPACK FOOTER //
// ./src/request/api.js